import { useCardActions } from '@/hooks/cards/useCardActions'
import { useCardCollectionHandlers } from '@/hooks/cards/useCardCollectionHandlers'
import { useCardListHandlers } from '@/hooks/cards/useCardListHandlers'
import { useCollectionItemByCard } from '@/hooks/collections/useCollectionQueries'

const quantityFor = (quantities: Record<number, number>, cardId: number | undefined) =>
  cardId ? quantities[cardId] || 0 : 0

const isHiddenCard = (hiddenCards: number[] | undefined, cardId: number | undefined) =>
  cardId ? (hiddenCards?.includes(cardId) ?? false) : false

export function useCardDetailActions(cardId: number | undefined) {
  const actions = useCardActions()
  const { quantities, buylistQuantities, selllistQuantities, userFilters } = actions

  const ownedQuantity = quantityFor(quantities, cardId)
  const onBuylist = quantityFor(buylistQuantities, cardId)
  const onSelllist = quantityFor(selllistQuantities, cardId)
  const isCardHidden = isHiddenCard(userFilters?.hiddenCards, cardId)

  // Fetch the actual collection item so we can show condition / notes.
  // Only runs when the user has the card in their collection.
  const { data: ownedItem } = useCollectionItemByCard(ownedQuantity > 0 ? cardId : undefined)

  return {
    isHidden: isCardHidden,
    ownedQuantity,
    ownedCondition: ownedItem?.condition ?? null,
    onBuylist,
    onSelllist,
    ...useCardCollectionHandlers(cardId, actions),
    ...useCardListHandlers(cardId, actions, onBuylist, onSelllist),
  }
}
